export enum TemplateType {
  CONTRAT = 'CONTRAT',
  CERTIFICATE = 'CERTIFICATE',
  SANCTION = 'SANCTION',
  AUTRE = 'AUTRE',
}
